import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatBudgetPeriod`

export default defineMessages({
  quarterLabel: {
    id: `${scope}.quarterLabel`,
    defaultMessage: `Quarter {quarter} {year}`,
  },
})
